export function getEnumObject(object) {
  return Object.keys(object).reduce(
    (previousValue, currentValue) => ({
      ...previousValue,
      [object[currentValue]]: currentValue,
    }),
    {}
  );
}
